import { useQueryGetAllUiPreferences } from "@apis:ui_preferences/ui_preferences";
import { useUser } from "@libs:react-query-auth";
import { useMemo } from "react";

type UserPreference = {
  botsScrollEnabled?: boolean | null;
};

export const useCheckBotsScroll = () => {
  const user = useUser().data;
  const userId = user?.id;

  const { data: uiPreferences, isLoading } = useQueryGetAllUiPreferences(
    true,
    userId,
    undefined,
    {
      enabled: !!userId,
    },
  );

  const isScrollEnabled = useMemo(() => {
    if (!uiPreferences || !userId) return false;

    const userPreference = uiPreferences.find(
      (pref) => pref.userId === userId && !pref.botId,
    );
    const userScrollEnabled = (userPreference?.preference as UserPreference)
      ?.botsScrollEnabled;

    return userScrollEnabled === true;
  }, [uiPreferences, userId]);

  return {
    isScrollEnabled,
    isLoading,
  };
};
